module.exports = __webpack_public_path__ + "img/hdd-rack.31f16c93.svg";